import { IconChevronLeft, IconLoader2 } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useChannelInstallationMutation,
  useConnectChannelMutation,
  useConnectionDetails,
  useFetchChannelDetails,
  useInstallApplicationMutation,
} from "../../../apis/integrationApis";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import NewSelectInput from "../../../components/NewSelectInput";
import { useMerchantAllListData } from "../../../apis/merchantApis";
import { Control, useForm, UseFormClearErrors } from "react-hook-form";
import CredentialsModal from "./CredentialsModal";
import CommonModal from "../../../components/common/CommonModal";

interface ProductRequestModalProps {
  // data: any;
  setValue?: any;
  watch?: any;
  register?: any;
  errors?: any;
  clearErrors?: any;
}

 

const Install = ({}: ProductRequestModalProps) => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const profile = useSelector((state: any) => state.auth.profile);

  const [openCredential, setOpenCredential] = useState(false);
  const [webhookUrl, setWebhookUrl] = useState<string>("");

  const { data: clients } = useMerchantAllListData();
  const {
    data: channelData,
    refetch,
    isFetched,
  } = useFetchChannelDetails(id ?? "");
  const { mutate: createDRS } = useConnectionDetails();
  const { mutate: installMutate, isPending } = useChannelInstallationMutation(
    id ?? ""
  );
  console.log(channelData, "c...");

  const [connectionData, setConnectionData] = useState<any>(channelData);

  // ✅ React Hook Form setup
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm<any>();
  // console.log(isFetched,'si')

  useEffect(() => {
    // refetch();
    if (isFetched) {
      setConnectionData(channelData);
    }
  }, [id, isFetched]);

  // 🔹 Install app before connection
  const handleInstall = () => {
    const selectedClientId = watch("clientId");

    if (channelData?.installationType === "client" && !selectedClientId) {
      toast.error("Please select a client before installing.");
      return;
    }

    const payload = {
      channelId: id ?? "",
      userId: profile?.id ?? "",
      clientId: selectedClientId ?? null,
      requestId: channelData?.requestedId ?? "",
    };

    installMutate(payload, {
      onSuccess: (res: any) => {
        setConnectionData(res);
        console.log(res, "res");
        // if (res?.webhookUrl) {
        //   setWebhookUrl(res.webhookUrl);
        // }
        // window.open("https://www.shopify.com/in", "_blank");
      },
      onError: (error: any) => {
        console.error("Install Error:", error);
        toast.error(error?.message || "Something went wrong!");
      },
    });
  };

  // 🔹 Fetch connection details for selected client
  const handleClientSelect = async (clientId: string) => {
    const sender = clients?.find((client: any) => client?.id === clientId);
    if (!sender) return;

    setValue("clientId", clientId);

    const payload = {
      clientId: clientId,
      channelId: id,
    };
    createDRS(payload, {
      onSuccess: (res: any) => {
        setConnectionData(res.data);
      },
      onError: (error: any) => {
        console.error(error);
        setConnectionData({ status: "INSTALL" });
      },
    });
  };

  // 🔹 Submit credentials to connect channel
  const handleConnect = handleSubmit((formData) => {
    const selectedClientId = watch("clientId");

    if (!selectedClientId) {
      toast.error("Please select a Client before connecting.");
      return;
    }

    const payload: any = {
      ...formData,
      channelId: id,
      clientId: selectedClientId,
    };

    installMutate(payload, {
      onSuccess: (res: any) => {
        toast.success("✅ Shopify connected successfully!");
        console.log("Shopify Connection Response:", res);
        reset();
        setOpenCredential(false);
      },
      onError: (err: any) => {
        toast.error(err?.message || "❌ Failed to connect Shopify");
      },
    });
  });

  console.log(connectionData, "c");
  return (
    <>
      <div className="xl:w-[65rem] w-full mx-auto text-[#1E293B] space-y-6">
        {/* Header */}
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="p-1.5 border border-gray-300 rounded-full hover:bg-gray-100 transition"
            >
              <IconChevronLeft strokeWidth={2} size={22} />
            </button>
            <div className="flex items-center gap-2">
              <img
                src={channelData?.companyLogo || "/img/image (6).png"}
                className="w-14 h-14 rounded object-contain border border-gray-200"
                alt={channelData?.companyName}
              />
              <h1 className="text-xl font-medium text-[#212121]">
                {channelData?.companyName || "Shopify"}
              </h1>
            </div>
          </div>

          <div className="flex items-center gap-2">
            {channelData?.installationType === "client" && (
              <>
                <p>Select Client</p>
                <NewSelectInput
                  className="col-span-2 w-60"
                  name="clientId"
                  register={register}
                  placeholder="Select Client"
                  error={errors?.clientId}
                  clearErrors={clearErrors}
                  validation={{ required: "Please select Client" }}
                  onChange={(val) => setValue("clientId", val)}
                  value={watch("clientId")}
                  setValue={handleClientSelect}
                  selectOptions={
                    clients?.map((client: any) => ({
                      id: client?.id,
                      value: client?.id,
                      text: client?.name,
                    })) || []
                  }
                />
              </>
            )}

            {connectionData?.status === "Not Installed" ? (
              <button
                onClick={handleInstall}
                disabled={isPending}
                className={`flex items-center gap-2 px-5 py-2 rounded-md text-sm font-medium transition
            ${
              isPending
                ? "bg-gray-400 cursor-not-allowed text-white"
                : "bg-[#212121] text-white hover:bg-[#333333]"
            }`}
              >
                {isPending && (
                  <IconLoader2
                    className="animate-spin"
                    size={18}
                    strokeWidth={2}
                  />
                )}
                {isPending ? "Installing..." : "Install"}
              </button>
            ) : (
              <>
                {(connectionData?.status === "Installed" ||
                  connectionData?.status === "installed") && (
                  <button
                    // onClick={() =>
                    //   navigate(
                    //     `/integration/${channelData?.id}/connect/${channelData?.installedId}`
                    //   )
                    // }
                    onClick={() => {
                      navigate(`/integration/${channelData?.id}/connect`);
                    }}
                    className={`flex items-center gap-2 px-5 py-2 rounded-md text-sm font-medium transition
              ${
                isPending
                  ? "bg-blue-200 cursor-not-allowed text-white"
                  : "bg-blue-400 text-white hover:bg-[#333333]"
              }`}
                  >
                    Connect
                  </button>
                )}
                {connectionData?.status === "CONNECTED" && (
                  <button
                    className="flex items-center gap-2 px-5 py-2 rounded-md text-sm font-medium transition bg-green-400 cursor-not-allowed text-white"
                    disabled={true}
                  >
                    Connected
                  </button>
                )}
              </>
            )}
          </div>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 space-y-6">
          {/* Logo */}
          <div className="flex justify-center">
            <img
              src={
                channelData?.companyLogo ||
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQZIhhiLHH0Qzp9Eqy9CcOFC5Tda9AUZas4Q&s"
              }
              className="w-full object-contain rounded-3xl"
              alt=""
            />
          </div>

          {/* Steps */}

          <div className="space-y-4">
            {/* Title + Introduction */}
            <section>
              <h2 className="text-lg font-semibold text-gray-900">
                {channelData?.installationSteps?.title
                  ? channelData.installationSteps.title
                  : `How to Connect Your ${channelData?.companyName}`}
              </h2>
              <p className="text-gray-600 text-sm">
                {channelData?.installationSteps?.introduction}
              </p>
            </section>

            {/* Dynamic Sections */}
            {channelData?.installationSteps?.sections?.map(
              (section: any, index: number) => (
                <section key={index}>
                  <h2 className="text-base font-semibold text-gray-900">
                    {section.heading}
                  </h2>

                  {/* Optional body text */}
                  {section.body && (
                    <p className="text-gray-600 text-sm">{section.body}</p>
                  )}

                  {/* Steps (list) */}
                  {section?.steps && section.steps.length > 0 && (
                    <ul
                      className={`${
                        section.heading?.toLowerCase().includes("prerequisite")
                          ? "list-disc"
                          : "list-decimal"
                      } pl-6 text-gray-600 text-sm space-y-1`}
                    >
                      {section.steps.map((step: string, stepIndex: number) => (
                        <li key={stepIndex}>{step}</li>
                      ))}
                    </ul>
                  )}
                </section>
              )
            )}
          </div>
        </div>
      </div>
      {/* <CommonModal
        key="shopify-credential-modal"
        title="Shopify Credentials"
        open={openCredential}
        closeButtonText="Cancel"
        onClose={() => {
          reset();
          setOpenCredential(false);
        }}
        actionButtonText={isPending ? "Connecting..." : "Connect"}
        actionButtonOnClick={handleConnect}
        actionButtonProps={{ disabled: isPending }}
      >
        {isPending && (
          <div className="flex justify-center mb-3">
            <IconLoader2 className="animate-spin" size={22} />
          </div>
        )}
        <CredentialsModal
          register={register}
          errors={errors}
          tab="Shopify"
          channelType="Shoapify"
        />
      </CommonModal> */}
    </>
  );
};

export default Install;
